<template>
<div class="page-wrapper">
             <main-navigation></main-navigation>


 
   
  <div class="add-house-container">

    <!-- LEFT INFO PANEL -->
    <div class="info-section">
      <h2 class="title">Add a New House</h2>
      <p class="subtitle">
        Create a new house entry and assign units later.  
        Keep your property records clean and organized.
      </p>

      <ul class="info-points">
        <li><i class="bi bi-check-circle"></i> Track houses easily</li>
        <li><i class="bi bi-check-circle"></i> Add unlimited units</li>
        <li><i class="bi bi-check-circle"></i> Manage tenants</li>
        <li><i class="bi bi-check-circle"></i> Attach payments automatically</li>
      </ul>

      <img src="../../assets/rent1.png" class="illustration" alt="House Illustration" />
    </div>

    <!-- RIGHT FORM -->
    <div class="form-section card shadow-sm p-4">

      <h4 class="fw-bold mb-3">House Details</h4>

      <form @submit.prevent="saveHouse">

        <div class="mb-3">
          <label class="form-label">House Name</label>
          <input v-model="house.name" class="form-control form-control-lg" required />
        </div>

        <div class="mb-3">
          <label class="form-label">Location</label>
          <input v-model="house.location" class="form-control form-control-lg" required />
        </div>

        <div class="mb-3">
          <label class="form-label">Description (optional)</label>
          <textarea v-model="house.description" rows="4" class="form-control"></textarea>
        </div>

        <button class="btn btn-primary btn-lg w-100">Save House</button>
      </form>

    </div>

  </div>
     </div>
</template>

<script>
import { apiFetch } from "@/services/api.js";   // 👈 HERE (top)

export default {
  data() {
    return {
      house: {
        name: "",
        location: "",
        description: ""
      },
      loading: false
    };
  },

  methods: {
    async saveHouse() {
  try {
    this.loading = true;

    // apiFetch already returns JSON
    const result = await apiFetch("/houses", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(this.house)
    });

    // Handle backend error
    if (!result.success) {
      throw new Error(result.message || "Failed to save house");
    }

    console.log("House saved:", result.data);

    // Redirect after success
    this.$router.push("/houses");

  } catch (error) {
    console.error("Error saving house:", error);
    alert(error.message || "Failed to save house. Please try again.");
  } finally {
    this.loading = false;
  }
}
  }
};
</script>


<style scoped>
.add-house-container {
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: 40px;
  padding: 40px;
  /* min-height: 90av; FIXED HEIGHT */
  background: var(--dash-bg-alt);
}
/* LEFT SIDE */
.info-section {
  padding: 20px 10px;
}

.title {
  font-size: var(--dash-fs-display);
  font-weight: 700;
  color: var(--dash-primary);
}

.subtitle {
  font-size: 15px;
  margin-top: 10px;
  color: var(--dash-muted);
}

.info-points {
  margin-top: 25px;
  list-style: none;
  padding: 0;
}

.info-points li {
  margin-bottom: 12px;
  font-size: 15px;
  display: flex;
  align-items: center;
  color: var(--dash-text);
}

.info-points i {
  color: var(--dash-primary);
  margin-right: 8px;
  font-size: 18px;
}

.illustration {
  width: 80%;
  margin-top: 25px;
  border-radius: 15px;
}

/* FORM SECTION */
.form-section {
  background: #fff;
  border-radius: var(--dash-radius-lg);
  padding: 30px;
}

.page-wrapper {
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}


/* RESPONSIVE */
@media (max-width: 992px) {
  .add-house-container {
    grid-template-columns: 1fr;
    padding: 20px;
  }

  .illustration {
    width: 60%;
  }
}
</style>
